import React from "react";
import clsx from "clsx";

export function GradeBadge({ grade, className }) {
  if (!grade) {
    return (
      <span
        className={clsx("inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold badge-slate", className)}
        data-testid="grade-badge-none"
      >
        Ungraded
      </span>
    );
  }
  // Alpha/Beta/Gama is the canonical mapping going forward; A/B/C/D are legacy
  // labels migrated on startup but we still render gracefully if anything slips
  // through (e.g. cached export rows).
  const map = {
    Alpha: "badge-green",
    Beta: "badge-blue",
    Gama: "badge-amber",
    A: "badge-green", B: "badge-blue", C: "badge-amber", D: "badge-red",
  };
  const cls = map[grade] || "badge-slate";
  return (
    <span
      className={clsx("inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold", cls, className)}
      data-testid={`grade-badge-${grade}`}
    >
      {grade}
    </span>
  );
}

export function RagBadge({ status, className }) {
  const map = {
    green: { cls: "badge-green", label: "GREEN" },
    amber: { cls: "badge-amber", label: "AMBER" },
    red: { cls: "badge-red", label: "RED" },
    no_data: { cls: "badge-slate", label: "NO DATA" },
  };
  const s = map[status] || map.no_data;
  return (
    <span
      className={clsx("inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold", s.cls, className)}
      data-testid={`rag-badge-${status}`}
    >
      {s.label}
    </span>
  );
}

export function StatusBadge({ status, className }) {
  const map = {
    active: "badge-green",
    paused: "badge-amber",
    closed: "badge-slate",
    on_hold: "badge-amber",
    churned: "badge-red",
  };
  return (
    <span
      className={clsx("inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold capitalize",
        map[status] || "badge-slate", className)}
      data-testid={`status-badge-${status}`}
    >
      {String(status || "-").replace("_", " ")}
    </span>
  );
}

export function ClassificationBadge({ classification }) {
  const map = {
    positive: "badge-green",
    adverse: "badge-red",
    neutral: "badge-slate",
  };
  return (
    <span className={clsx("inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold capitalize",
      map[classification] || "badge-slate")}>
      {classification}
    </span>
  );
}
